export default {"src":"/_next/static/media/facebook_icon_black.05dc6f27.svg","height":56,"width":56};